import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M213.333 960c0-167.36 56-321.707 149.44-446.4L1406.4 1557.227c-124.693 93.44-279.04 149.44-446.4 149.44-411.627 0-746.667-335.04-746.667-746.667m1493.334 0c0 167.36-56 321.707-149.44 446.4L513.6 362.773c124.693-93.44 279.04-149.44 446.4-149.44 411.627 0 746.667 335.04 746.667 746.667M960 0C429.76 0 0 429.76 0 960s429.76 960 960 960 960-429.76 960-960S1490.24 0 960 0",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconNoSolid =
/*#__PURE__*/
function (_Component) {
  _inherits(IconNoSolid, _Component);

  function IconNoSolid() {
    _classCallCheck(this, IconNoSolid);

    return _possibleConstructorReturn(this, _getPrototypeOf(IconNoSolid).apply(this, arguments));
  }

  _createClass(IconNoSolid, [{
    key: "render",
    value: function render() {
      return React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconNo",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconNoSolid.displayName = "IconNoSolid";
  return IconNoSolid;
}(Component);

IconNoSolid.glyphName = 'no';
IconNoSolid.variant = 'Solid';
IconNoSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconNoSolid;
export { IconNoSolid };